import { render, staticRenderFns } from "./NewProductType.vue?vue&type=template&id=3ea67b26"
import script from "./NewProductType.vue?vue&type=script&lang=js"
export * from "./NewProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports